<template>
  <v-container v-if="pedido" class="pb-10">
    <Navbar
      :hasBackButton="true"
      :hasTabs="true"
      @tabChanged="currentTab = $event"
      @backButtonClicked="cancel"
      :title="`${statusText(pedido.status)} #${id}`"
    >
      <template slot="actions">
        <v-btn text @click="save">
          Salvar
        </v-btn>
        <Menu
          :items="menuItems"
          @gerarPedido="geraPedido"
          @enviarEmail="openModalEmail"
          @visualizar="visualizarOrcamento"
          @informacoesCliente="obterInformacoesCliente"
          @excluir="excluirPedido"
        />
      </template>
      <!-- Tabs -->
      <v-row column slot="Dados" class="grey lighten-3">
        <a :href="sendEmail.href" ref="sendEmail" style="display: none;">Enviar E-mail</a>
        <v-col cols="12" class="pt-0">
          <v-card>
            <v-card-text class="py-2">
              <ModalInfoCliente
                :modal="modalInfoCliente"
                :cliente="clienteInformacoes"
                @atualizaFinanceiroCliente="atualizaFinanceiroCliente"
                @close="closeInformacoesCliente"
              />
              <ModalCliente
                :modal="modalCliente"
                @close="modalCliente = false"
                @save="changeCliente"
              />
              <ModalCompartilharOrcamento
                :item="itemCompartilhar"
                :modal="modalCompartilhar"
                @close="closeModalCompartilhar"
              />
              <div class="text-right">
                <v-chip
                  small
                  label
                  :color="statusColor(pedido.status)"
                  class="font-weight-bold"
                >{{ statusText(pedido.status) }}</v-chip>
              </div>
              <v-list class="pb-0">
                <v-divider></v-divider>
                <v-list-item
                  class="pa-0"
                  @click="modalCliente = true"
                  :disabled="!!(pedido.cliente && pedido.itens && pedido.itens.length)"
                >
                  <v-list-item-avatar class="ma-0">
                    <v-icon :disabled="!!(pedido.cliente && pedido.itens && pedido.itens.length)">mdi-store</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>{{ pedido.cliente }}</v-list-item-title>
                  <v-list-item-action class="ma-0">
                    <v-icon :disabled="!!(pedido.cliente && pedido.itens && pedido.itens.length)">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>

                <ModalEmissao
                  :modal="modalEmissao"
                  :editEmissao="editEmissao"
                  @close="closeModalEmissao"
                  @save="changeEmissao"
                />
                <v-list-item
                  class="pa-0"
                  @click="editSaidaEmissao"
                  :disabled="!permiteAlterar"
                >
                  <v-list-item-avatar class="ma-0">
                    <v-icon :disabled="!permiteAlterar">mdi-calendar</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>{{ pedido.data_emissao | dateMonthYear }}</v-list-item-title>
                  <v-list-item-action class="ma-0">
                    <v-icon :disabled="!permiteAlterar">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <CardListItem
                  icon="mdi-tag"
                  :flat="true"
                  :disabled="!permiteAlterar || !permiteAlterarTabelaPreco"
                  :text="pedido.tabela_preco || 'Tabela de Preço'"
                  @clicked="modalTabelaPreco = true"
                />
                <ModalTabelaPreco
                  :modal="modalTabelaPreco"
                  @close="modalTabelaPreco = false"
                  @save="changeTabelaPreco"
                />
                <v-divider></v-divider>
                <v-list-item
                  class="pa-0"
                  @click="observacoes = !observacoes"
                  :disabled="!permiteAlterar"
                >
                  <v-list-item-avatar class="ma-0">
                    <v-icon :disabled="!permiteAlterar">mdi-text-box</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>Observações</v-list-item-title>
                  <v-list-item-action class="ma-0">
                    <v-icon :disabled="!permiteAlterar">mdi-chevron-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <v-textarea
                  v-if="observacoes"
                  v-model="pedido.observacoes"
                  label="Observações"
                  hide-details
                  :disabled="!permiteAlterar"
                ></v-textarea>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col v-if="permiteAlterar" cols="12" class="pt-0">
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            color="primary"
            @click="geraPedido"
          >Gerar Pedido</v-btn>
        </v-col>

        <v-col cols="12" class="pt-0">
          <v-btn
            :disabled="!permiteAlterar"
            :block="$vuetify.breakpoint.xsOnly"
            color="error"
            @click="excluirPedido"
          >Excluir</v-btn>
        </v-col>
      </v-row>

      <!-- Itens -->
      <v-row column slot="Itens" class="grey lighten-3">
        <v-col cols="12" class="py-0">
          <Catalogo
            :modal="modalCatalogo"
            :produtoInformacoes="produtoInformacoes"
            :produtoInformacoesLoading="produtoInformacoesLoading"
            :tabelaPreco="tabelaPreco"
            @adicionaProdutosSelecionados="adicionaProdutosSelecionados"
            @obterInformacoes="obterInformacoesProduto"
            @closeInformacoesProduto="closeInformacoesProduto"
            @close="modalCatalogo = false"
          />
          <ModalProduto
            :modal="modalProduto"
            :editProduto="editProduto"
            :tabelaPreco="tabelaPreco"
            @close="closeModalProduto"
            @save="addProduto"
            @update="updateProduto"
            @remove="removeProduto"
          />
        </v-col>
        <v-col cols="12" class="py-0">
          <v-card
            :disabled="!permiteAlterar"
            v-for="(item, i) in pedido.itens"
            :key="i"
            @click="editItem(item)"
            class="mb-2"
            :class="{ 'mb-5': i === pedido.itens.length - 1 }"
          >
            <v-card-text class="pa-3">
              <v-row column class="align-center">
                <v-col cols="10" class="py-0">
                  <p class="ma-0 font-weight-bold">{{ item.descricao }}</p>
                  <p class="ma-0 body-2">Qtde: {{ item.qtde_produto }} {{ item.unidade }} x {{ item.preco_bruto | price }}</p>
                  <p v-if="item.desconto" class="ma-0 red--text">Desconto: {{ item.desconto | price }}</p>
                  <p class="ma-0 body-2">Total: {{ item.subtotal | price }}</p>
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Parcelas -->
      <v-row column slot="Parcelas" class="grey lighten-3">
        <v-col cols="12" class="py-0">
          <CardListItem
            :disabled="!permiteAlterar"
            icon="mdi-currency-usd"
            :text="pedido.condicao_pagamento"
            @clicked="modalCondicaoPagamento = true"
          />
          <ModalCondicaoPagamento
            :modal="modalCondicaoPagamento"
            @close="modalCondicaoPagamento = false"
            @save="changeCondicaoPagamento"
          />
        </v-col>
        <v-col cols="12">
          <ModalParcela
            :modal="modalParcela"
            :editParcela="editParcela"
            :valorRestante="valorRestanteParcela"
            @close="closeModalParcela"
            @save="addParcela"
            @update="updateParcela"
            @remove="removeParcela"
          />
          <v-card
            :disabled="!permiteAlterar"
            v-for="(item, i) in pedido.parcelas"
            :key="i"
            @click="editSaidaParcela(item)"
            class="mb-3"
          >
            <v-card-text class="pa-3">
              <v-row column class="align-center">
                <v-col cols="10" class="py-0">
                  <p class="ma-0 font-weight-bold">{{ item.tipo_documento }}</p>
                  <p class="ma-0 body-2">Vencimento: {{ item.data_vencimento | dateMonthYear }}</p>
                  <p class="ma-0 body-2">{{ item.valor_parcela | price }}</p>
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </Navbar>

    <ModalError
      :modal="modalError"
      :erros="erros"
      @close="closeModalError"
    />

    <ModalEmail
      :modal="modalEmail"
      :emails="sendEmail.emails"
      @close="modalEmail = false"
      @save="enviarEmail"
    />

    <!-- Button Modal Produto -->
    <v-fab-transition>
      <v-btn
        v-if="currentTab === 'tab-Itens' && permiteAlterar && !modalCatalogo"
        fixed
        fab
        dark
        bottom
        right
        color="primary"
        style="bottom: 60px;"
        @click="abreModalProduto"
      ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>

    <!-- Button Modal Parcelas -->
    <v-fab-transition>
      <v-btn
        v-if="currentTab === 'tab-Parcelas' && pedido.id_condicao_pagamento === 0 && valorRestanteParcela > 0 && permiteAlterar"
        fixed
        fab
        dark
        bottom
        right
        color="success"
        style="bottom: 60px;"
        @click="modalParcela = true"
      ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-bottom-sheet v-model="sheet">
      <v-sheet>
        <v-col cols="12">
          <div class="d-flex justify-end">
            <v-btn
              icon
              @click="sheet = !sheet"
              ><v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="d-flex justify-space-between my-2">
            Total Bruto: <strong>{{ totalBruto | price }}</strong>
          </div>
          <v-divider></v-divider>
          <div class="d-flex justify-space-between my-2 red--text">
            Desconto: <strong>{{ totalDesconto | price }} ({{ totalDescontoPerc }}%)</strong>
          </div>
          <v-divider></v-divider>
          <div class="d-flex justify-space-between my-2">
            Total: <strong>{{ totalProduto | price }}</strong>
          </div>
          <v-divider></v-divider>
          <div class="d-flex justify-space-between mt-2">
            Quantidade Total: <strong>{{ qtdeTotal }}</strong>
          </div>
        </v-col>
      </v-sheet>
    </v-bottom-sheet>

    <v-footer
      v-if="!modalCatalogo"
      fixed
      class="font-weight-medium"
    >
      <v-col
        @click="sheet = true"
        class="pa-0"
        cols="12"
      >
        <div class="d-flex justify-space-between align-center">
          <span class="pr-1">Total:</span> <strong>{{ totalProduto | price }}</strong>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-footer>
    <ModalLoading
      :modal="modalLoading"
    />
  </v-container>
  <PageLoading v-else />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { hrefMailGenerator, increaseDateByDays } from '@/helpers';
import { generateEmailOrcamento } from '@/emailOrcamentoHelper';
import Navbar from '@/components/layout/Navbar';
import { pedidoService } from '@/services/pedidoService';
import { clienteService } from '@/services/clienteService';
import { empresaService } from '@/services/empresaService';
import ModalCliente from '@/components/shared/ModalCliente';
import ModalEmissao from '@/components/shared/ModalEmissao';
import ModalCondicaoPagamento from '@/components/shared/ModalCondicaoPagamento';
import ModalTabelaPreco from '@/components/shared/ModalTabelaPreco';
import ModalParcela from '@/components/shared/ModalParcela';
import ModalProduto from '@/components/shared/ModalProduto';
import Menu from '@/components/shared/Menu';
import CardListItem from '@/components/shared/card/CardListItem';
import ModalError from '@/components/shared/ModalError';
import ModalEmail from '@/components/shared/ModalEmail';
import Catalogo from '@/components/shared/Catalogo';
import ProdutoInfo from '@/domain/ProdutoInfo';
import ModalInfoCliente from '@/components/clientes/ModalInfoCliente';

export default {
  name: 'Pedido',
  props: ['id'],
  components: {
    Navbar,
    ModalCliente,
    ModalEmissao,
    ModalCondicaoPagamento,
    ModalTabelaPreco,
    ModalParcela,
    ModalProduto,
    Menu,
    CardListItem,
    ModalError,
    ModalEmail,
    Catalogo,
    ModalInfoCliente,
    ModalCompartilharOrcamento: () => import('@/components/shared/ModalCompartilharOrcamento'),
    ModalLoading: () => import('@/components/shared/ModalLoading'),
  },
  data: () => ({
    modalEmissao: false,
    modalCliente: false,
    modalCondicaoPagamento: false,
    modalTabelaPreco: false,
    modalParcela: false,
    modalProduto: false,
    modalError: false,
    modalEmail: false,
    modalCompartilhar: false,
    modalLoading: false,
    modalCatalogo: false,
    modalInfoCliente: false,
    editEmissao: null,
    editProduto: null,
    editParcela: null,
    pedido: null,
    cliente: null,
    error: '',
    erros: [],
    sheet: false,
    currentTab: null,
    observacoes: false,
    tabelaPreco: null,
    produtoInformacoes: null,
    clienteInformacoes: null,
    produtoInformacoesLoading: false,
    itemCompartilhar: null,
    sendEmail: {
      href: 'mailto:',
      emails: []
    }
  }),
  computed: {
    ...mapGetters([
      'condicoesPagamento', 
      'tabelasPreco', 
      'permiteAlterarTabelaPreco', 
      'salvaOrcamentoAuto',
      'utilizaCatalogoProduto',
      'validadeOrcamento',
      'colaborador',
      'realizaBackupAoSalvar'
    ]),
    menuItems() {
      return this.pedido.id_saida ? 
      [
        { title: 'Gerar Pedido', value: 'gerarPedido', disabled: true },
        { title: 'Enviar E-mail', value: 'enviarEmail' },
        { title: 'Visualizar Impressão', value: 'visualizar' },
        { title: 'Informações Cliente', value: 'informacoesCliente' },
        { title: 'Excluir', value: 'excluir', color: 'red--text', disabled: true },
      ] :
      [
        { title: 'Gerar Pedido', value: 'gerarPedido' },
        { title: 'Enviar E-mail', value: 'enviarEmail' },
        { title: 'Visualizar Impressão', value: 'visualizar' },
        { title: 'Informações Cliente', value: 'informacoesCliente' },
        { title: 'Excluir', value: 'excluir', color: 'red--text' },
      ];
    },
    existeItensAdicionados() {
      return !!(this.pedido.itens && this.pedido.itens.length);
    },
    permiteAlterar() {
      return this.pedido.status.startsWith('O');
    },
    valorRestanteParcela() {
      if (this.pedido && this.pedido.parcelas) return this.pedido.parcelas.reduce((acc, cur) => Number(acc) - Number(cur.valor_parcela), this.totalProduto);
      return 0;
    },
    totalProduto() {
      if (this.pedido && this.pedido.itens) return this.pedido.itens.reduce((acc, cur) => Number(cur.subtotal) + acc, 0);
      return 0;
    },
    totalDesconto() {
      if (this.pedido && this.pedido.itens) return this.pedido.itens.reduce((acc, cur) => Number(cur.desconto) + acc, 0);
      return 0;
    },
    totalDescontoPerc() {
      if (this.pedido && this.pedido.itens) {
        const totalDescontos = this.pedido.itens.reduce((acc, cur) => Number(cur.desconto) + acc, 0);
        const totalDescontoPerc = totalDescontos / this.totalBruto * 100;
        return isNaN(totalDescontoPerc) ? 0 : totalDescontoPerc.toFixed(2);
      }
      return 0;
    },
    totalBruto() {
      if (this.pedido && this.pedido.itens) return this.pedido.itens.reduce((acc, cur) => Number(cur.subtotal_bruto) + acc, 0);
      return 0;
    },
    totalBrutoParcelas() {
      if (this.pedido && this.pedido.parcelas) return this.pedido.parcelas.reduce((acc, cur) => Number(cur.valor_parcela) + acc, 0);
      return 0;
    },
    qtdeTotal() {
      if (this.pedido && this.pedido.itens) {
        const totalItems = this.pedido.itens.reduce((acc, cur) => Number(cur.qtde_produto) + acc, 0);
        if (totalItems > 1) return `${totalItems} itens`;
        if (totalItems === 1) return `${totalItems} item`;
      }
      return 0;
      // return this.pedido ? this.pedido.itens.length > 1 ? `${this.pedido.itens.length} itens` : `${this.pedido.itens.length} item` : 0;
    },
    scrollableContainer() {
      if (this.pedido) {
        const offset = 40;
        const windowHeight = window.outerHeight;
        const navigationHeight = 104;
        const scrollableContainerHeight = windowHeight - navigationHeight - offset;
        return {
          maxHeight: scrollableContainerHeight.toString() + 'px',
          overflow: 'auto'
        }
      } else {
        return { maxHeight: 400 + 'px', overflow: 'auto' };
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchPedidoItensAPI', 
      'fetchPedidoParcelasAPI', 
      'fetchCondicoesPagamento', 
      'fetchTabelasPreco', 
      'updatePedido', 
      'deletePedido', 
      'deletePedidoSilent',
      'gerarPedido',
      'fetchClienteFinanceiroAPI',
      'verifyAndSendBackupOnline'
    ]),
    ...mapMutations(['SHOW_SNACKBAR']),
    abreModalProduto() {
      if (this.utilizaCatalogoProduto) {
        this.modalCatalogo = true;
      } else {
        this.modalProduto = true;
      }
    },
    closeInformacoesProduto() {
      this.produtoInformacoes = null;
    },
    closeInformacoesCliente() {
      this.modalInfoCliente = false;
      this.clienteInformacoes = null;
    },
    // TODO: Finalizar função para atualizar as informações financeira
    async atualizaFinanceiroCliente() {
      this.clienteInformacoes = null;
      this.cliente = await this.fetchClienteFinanceiroAPI(this.cliente);
      this.obterInformacoesCliente();
    },
    obterInformacoesCliente() {
      this.clienteInformacoes = this.cliente;
      this.modalInfoCliente = true;
    },
    async obterInformacoesProduto(produto) {
      try {
        const { data } = await clienteService.getClienteProdutoVendidoAPI(this.pedido.id_cliente, produto.id_produto);
        const informacoes = data.Sql && data.Sql[0];

        if (informacoes) {
          this.produtoInformacoes = { ...produto, informacoes };
        } else {
          this.produtoInformacoes = { ...produto, informacoes: new ProdutoInfo() }
        }
      } catch (error) {
        console.log(error);
        this.produtoInformacoes = { ...produto }
      }
    },
    calculaTotalItens(items) {
      for (const item of items) {
        item.subtotal_bruto = item.preco_bruto * item.qtde_produto;
        item.subtotal = item.subtotal_bruto;
        item.preco_unitario = item.subtotal / item.qtde_produto;
        item.desconto = 0;
        item.perc_desconto = 0;
      }
    },
    adicionaProdutosSelecionados(produtos) {
      if (this.validateCliente()) {
        this.calculaTotalItens(produtos);

        for (const produto of produtos) {
          this.addProduto(produto);
        }
      } else {
        this.modalError = true;
      }
    },
    openModalEmail() {
      this.sendEmail.emails = this.cliente.emails;
      this.modalEmail = true;
    },
    formatItensMonetaryValues() {
      const itens = JSON.parse(JSON.stringify(this.pedido.itens));

      itens.forEach(item => {
        item.preco_unitario = this.$options.filters.price(item.preco_unitario);
        item.subtotal = this.$options.filters.price(item.subtotal);
      });

      return itens;
    },
    formatParcelasMonetaryAndDateValues() {
      const parcelas = JSON.parse(JSON.stringify(this.pedido.parcelas));

      parcelas.forEach(parcela => {
        parcela.valor_parcela = this.$options.filters.price(parcela.valor_parcela);
        parcela.data_vencimento = this.$options.filters.dateMonthYear(parcela.data_vencimento);
      });

      return parcelas;
    },
    async enviarEmail(emails) {
      const {
        id_interno,
        id_saida,
        data_emissao,
        id_cliente,
        condicao_pagamento,
        id_empresa,
        // itens,
        // parcelas,
        observacoes,
        total_bruto,
        total_desconto,
        total_produto
      } = this.pedido;

      let empresa = await empresaService.getEmpresa(id_empresa);

      if (!empresa) empresa = await empresaService.getEmpresaAPI(id_empresa);

      const item = {
        id_interno,
        id_saida,
        title: id_saida ? `Pedido #${id_saida}` : `Orçamento #${id_interno}`,
        data_emissao: this.$options.filters.dateMonthYear(data_emissao),
        data_validade: this.$options.filters.dateMonthYear(increaseDateByDays(data_emissao, this.validadeOrcamento)),
        vendedor: this.colaborador,
        cliente: this.cliente,
        id_cliente,
        condicao_pagamento,
        id_empresa,
        itens: this.formatItensMonetaryValues(),
        parcelas: this.formatParcelasMonetaryAndDateValues(),
        observacoes,
        total_bruto: this.$options.filters.price(total_bruto),
        total_desconto: this.$options.filters.price(total_desconto),
        total_produto: this.$options.filters.price(total_produto),
        empresa
      }

      const bodyEmail = generateEmailOrcamento(item);
      this.sendEmail.href = hrefMailGenerator(emails, `${empresa.nome_fantasia || ''} Orçamento #${id_interno}`, bodyEmail);
      this.$nextTick(() => this.$refs.sendEmail.click());
      this.modalEmail = false;
    },
    async visualizarOrcamento() {
      this.modalLoading = true;

      const {
        id_interno,
        id_saida,
        data_emissao,
        id_cliente,
        condicao_pagamento,
        id_empresa,
        itens,
        parcelas,
        observacoes,
        total_bruto,
        total_desconto,
        total_produto
      } = this.pedido;

      let empresa = await empresaService.getEmpresa(id_empresa);

      if (!empresa) empresa = await empresaService.getEmpresaAPI(id_empresa);

      const item = {
        id_interno,
        id_saida,
        title: id_saida ? `Pedido #${id_saida}` : `Orçamento #${id_interno}`,
        data_emissao,
        data_validade: increaseDateByDays(data_emissao, this.validadeOrcamento),
        vendedor: this.colaborador,
        cliente: this.cliente,
        id_cliente,
        condicao_pagamento,
        id_empresa,
        itens,
        parcelas,
        observacoes,
        total_bruto,
        total_desconto,
        total_produto,
        empresa
      }

      this.itemCompartilhar = item;
      this.modalLoading = false;
      this.modalCompartilhar = true;
    },
    getCondicoesPagamento() {
      if (!this.condicoesPagamento.length) {
        this.fetchCondicoesPagamento();
      }
    },
    getTabelasPreco() {
      if (!this.tabelasPreco.length) {
        this.fetchTabelasPreco();
      }
    },
    closeModalError() {
      this.erros = [];
      this.modalError = false
    },
    editSaidaEmissao() {
      this.editEmissao = this.pedido.data_emissao;
      this.modalEmissao = true
    },
    closeModalEmissao() {
      this.editEmissao = null;
      this.modalEmissao = false
    },
    closeModalCompartilhar() {
      this.itemCompartilhar = null;
      this.modalCompartilhar = false
    },
    editItem(item) {
      this.editProduto = {...item};
      this.modalProduto = true;
    },
    statusColor(status) {
      if (status.startsWith('O')) return 'warning';
      if (status.startsWith('A')) return 'success';
      if (status.startsWith('F')) return 'success';
      return 'error'
    },
    statusText(status) {
      if (status.startsWith('O')) return 'Orçamento';
      if (status.startsWith('A')) return 'Pedido';
      if (status.startsWith('F')) return 'Finalizado';
      return 'NDA'
    },
    changeCliente(cliente) {
      this.cliente = { ...cliente };
      this.pedido.id_cliente = cliente.id_cliente;
      this.pedido.id_cliente_interno = cliente.id_interno;
      this.pedido.cliente = cliente.nome_fantasia;
      this.pedido.razao_social = cliente.razao_social;
      this.pedido.nome_fantasia = cliente.nome_fantasia;
      this.pedido.id_condicao_pagamento = cliente.id_condicao_pagamento || 0;
      this.pedido.id_tabela_preco = cliente.id_tabela_preco;
      const condicaoPagamento = this.condicoesPagamento.find(cp => cp.id_condicao_pagamento === cliente.id_condicao_pagamento);
      if (condicaoPagamento) this.changeCondicaoPagamento(condicaoPagamento);
      const tabelaPreco = this.tabelasPreco.find(tp => tp.id_tabela_preco === cliente.id_tabela_preco);
      this.changeTabelaPreco(tabelaPreco);
      this.modalCliente = false;
      this.saveAuto();
    },
    changeEmissao(emissao) {
      this.pedido.data_emissao = emissao;
      this.updateSaidaParcelas();
      this.modalEmissao = false;
      this.saveAuto();
    },
    changeCondicaoPagamento(condicaoPagamento) {
      const { parcelas } = condicaoPagamento;
      const saidaParcelas = [];

      if (parcelas && parcelas.length) {
        parcelas.forEach((parcela, index) => {
          const saidaParcela = {
            id_saida: this.pedido.id_saida,
            id_parcela: index + 1,
            id_tipo_documento: parcela.id_tipo_documento,
            tipo_documento: parcela.tipo_documento,
            data_vencimento: this.calculateSaidaParcelaVencimento(parcela.qtde_prazo),
            valor_parcela: Number(this.totalProduto / parcelas.length)
          };
          saidaParcelas.push(saidaParcela);
        });
      } else {
        this.pedido.parcelas = [];
      }

      this.pedido.id_condicao_pagamento = condicaoPagamento.id_condicao_pagamento;
      this.pedido.condicao_pagamento = condicaoPagamento.condicao_pagamento;
      this.pedido.parcelas = [...saidaParcelas];

      this.modalCondicaoPagamento = false;
      this.saveAuto();
    },
    changeTabelaPreco(tabelaPreco) {
      if (tabelaPreco && typeof tabelaPreco === 'object') {
        this.pedido.id_tabela_preco = tabelaPreco.id_tabela_preco;
        this.pedido.tabela_preco = tabelaPreco.tabela_preco;
        this.tabelaPreco = { ...tabelaPreco };
      } else {
        this.pedido.id_tabela_preco = null;
        this.pedido.tabela_preco = '';
        this.tabelaPreco = null;
      }

      // TODO: Alterar preços do catálogo de produtos
      // OBS: Atualizar precos tenha uma tabela de preço,
      // caso nao, voltar os preços do catalogo
      // Criar função updatePrecoProdutosCatalogo
      // updatePrecoProdutosCatalogo()
      // TODO2: Analisando bem, é melhor atualizar os preços quando abrir o catálogo
      // Nesse caso pode-se passar o id_tabela_preco para o catálogo e o catálogo faz a lógica de atualização
      // Ou seja, sempre que o catálogo for aberto, será verificado se existe id_tabela_preco e realizado a lógica
      this.modalTabelaPreco = false;
    },
    calculateSaidaParcelaVencimento(dias) {
      const emissaoPedido = new Date(this.pedido.data_emissao);
      return dias > 0 ? new Date(emissaoPedido.setDate(emissaoPedido.getDate() + dias)) : emissaoPedido;
    },
    updateSaidaParcelas() {
      if (!this.pedido.id_condicao_pagamento) return;
      const condicaoPagamento = this.condicoesPagamento.find(condPagamento => condPagamento.id_condicao_pagamento === this.pedido.id_condicao_pagamento);
      this.changeCondicaoPagamento(condicaoPagamento);
    },
    getLastIdParcela() {
      const lastParcela = this.pedido.parcelas[this.pedido.parcelas.length - 1];
      if (lastParcela) return lastParcela.id_parcela + 1;
      else return 1;
    },
    editSaidaParcela(parcela) {
      this.editParcela = {...parcela};
      if (typeof this.editParcela.data_vencimento === 'object') this.editParcela.data_vencimento = this.editParcela.data_vencimento.toISOString().substr(0, 10);
      this.modalParcela = true;
    },
    addParcela(parcela) {
      if (Number(this.totalBrutoParcelas) + Number(parcela.valor_parcela) <= Number(this.totalProduto)) {
        parcela.id_parcela = this.getLastIdParcela();
        parcela.id_saida = this.pedido.id_saida;
        this.pedido.parcelas.push(parcela);
        this.closeModalParcela();
        this.saveAuto();
        // this.SHOW_SNACKBAR({ text: 'Parcela adicionada com sucesso.', status: 'success' });
      } else {
        this.SHOW_SNACKBAR({ text: 'Valor da parcela ultrapassa o valor do pedido.', status: 'error' });
      }
    },
    updateParcela(updParcela) {
      const parcelaOriginal = this.pedido.parcelas.find(parcela => parcela.id_parcela === updParcela.id_parcela);
      if ((Number(this.totalBrutoParcelas) - Number(parcelaOriginal.valor_parcela)) + Number(updParcela.valor_parcela) <= Number(this.totalProduto)) {
        const index = this.pedido.parcelas.findIndex(parcela => parcela.id_parcela === updParcela.id_parcela);
        if (index !== -1) {
          this.pedido.parcelas.splice(index, 1, updParcela);
        }
        this.closeModalParcela();
        this.saveAuto();
        // this.SHOW_SNACKBAR({ text: 'Parcela atualizada com sucesso.', status: 'success' });
      } else {
        this.SHOW_SNACKBAR({ text: 'Valor da parcela ultrapassa o valor do pedido.', status: 'error' });
      }
    },
    removeParcela(parcela) {
      if (confirm(`Deseja remover a parcela: ${parcela.id_parcela}?`)) {
        this.pedido.parcelas = this.pedido.parcelas.filter(p => p.id_parcela !== parcela.id_parcela);
        this.closeModalParcela();
        this.saveAuto();
        // this.SHOW_SNACKBAR({ text: 'Parcela removida com sucesso.', status: 'success' });
      }
    },
    closeModalParcela() {
      this.editParcela = null;
      this.modalParcela = false
    },
    getLastIdItem() {
      const lastItem = this.pedido.itens[this.pedido.itens.length - 1];
      if (lastItem) return lastItem.id_item + 1;
      else return 1;
    },
    calculaTotais() {
      this.pedido.total_produto = this.totalProduto;
      this.pedido.total_desconto = this.totalDesconto;
      this.pedido.total_bruto = this.totalBruto;
    },
    addProduto(produto) {
      if (this.validateCliente()) {
        const newProduto = { ...produto };
        newProduto.id_saida = this.pedido.id_saida;
        newProduto.id_item = this.getLastIdItem();
        this.pedido.itens.push(newProduto);
        this.updateSaidaParcelas();
        this.calculaTotais();
        this.saveAuto();
      } else {
        this.modalError = true;
      }

      this.closeModalProduto();
    },
    updateProduto(updProduto) {
      const index = this.pedido.itens.findIndex(item => item.id_item === updProduto.id_item);
      if (index !== -1) {
        this.pedido.itens.splice(index, 1, updProduto);
      }
      this.updateSaidaParcelas();
      this.closeModalProduto();
      this.calculaTotais();
      this.saveAuto();
      // this.SHOW_SNACKBAR({ text: 'Produto atualizado com sucesso.', status: 'success' });
    },
    removeProduto(produto) {
      if (confirm(`Deseja remover o item: ${produto.id_item}?`)) {
        this.pedido.itens = this.pedido.itens.filter(item => item.id_item != produto.id_item);
        this.updateSaidaParcelas();
        this.closeModalProduto();
        this.calculaTotais();
        this.saveAuto();
        // this.SHOW_SNACKBAR({ text: 'Produto removido com sucesso.', status: 'success' });
      }
    },
    closeModalProduto() {
      this.editProduto = null;
      this.modalProduto = false;
    },
    preparePedido() {
      this.calculaTotais();
      return { ...this.pedido }
    },
    async geraPedido() {
      if (this.validatePedido()) {
        if (confirm('Deseja gerar o pedido?')) {
          const updPedido = this.preparePedido();
          await this.gerarPedido(updPedido);
          this.$router.push({ name: 'Home' });
        }
      } else {
        this.SHOW_SNACKBAR({ text: 'Informe o cliente, emissão, condição pagamento, itens e parcelas.', status: 'error' });
      }
    },
    validateParcelas() {
      if (this.totalProduto === this.totalBrutoParcelas) {
        return true;
      } else {
        this.erros.push('Parcelas inválidas');
        return false;
      }
    },
    validateItens() {
      if (this.pedido.itens.length > 0) {
        return true;
      } else {
        this.erros.push('Nenhum item informado');
        return false;
      }
    },
    validateCliente() {
      if (this.pedido.id_cliente_interno) {
        return true;
      } else {
        this.erros.push('Nenhum cliente informado');
        return false;
      }
    },
    validateDataEmissao() {
      if (this.pedido.data_emissao) {
        return true;
      } else {
        this.erros.push('Data de emissão inválida');
        return false;
      }
    },
    validateCondicaoPagamento() {
      if (this.pedido.id_condicao_pagamento >= 0) {
        return true;
      } else{
        this.erros.push('Condição de pagamento inválida');
        return false;
      }
    },
    validatePedido() {
      if (
        this.validateCliente() &&
        this.validateDataEmissao() &&
        this.validateCondicaoPagamento() &&
        this.validateItens() &&
        this.validateParcelas()
      ) {
        return true;
      } else {
        return false;
      }
    },
    async saveAuto() {
      if (!this.salvaOrcamentoAuto) return;

      const updPedido = this.preparePedido();
      try {
        await this.updatePedido(updPedido);
      } catch (error) {
        this.SHOW_SNACKBAR({ text: error, status: 'error' });
      }
    },
    cancel() {
      if (!this.pedido.id_saida && this.existeItensAdicionados && confirm('Tem certeza que deseja voltar?')) {
        return this.$router.go(-1);
      } else if (!this.existeItensAdicionados && !this.pedido.id_saida) {
        this.deletePedidoSilent(this.pedido.id_interno);
        this.$router.go(-1);
      } else if (this.pedido.id_saida) {
        this.$router.go(-1);
      }
    },
    async save() {
      if (!this.permiteAlterar) return this.$router.go(-1);

      if (this.validatePedido()) {
        const updPedido = this.preparePedido();
        try {
          await this.updatePedido(updPedido);
          if (this.realizaBackupAoSalvar) this.verifyAndSendBackupOnline();
          this.$router.go(-1);
          // this.SHOW_SNACKBAR({ text: 'Pedido atualizado com sucesso.', status: 'success' });
        } catch (error) {
          console.log(error);
          this.SHOW_SNACKBAR({ text: error, status: 'error' });
        }
      } else {
        this.modalError = true;
      }
    },
    excluirPedido() {
      if (confirm(`Deseja excluir o registro ${this.pedido.id_interno}?`)) {
        this.deletePedido(this.pedido.id_interno);
        this.$router.push({ name: 'Home' });
      } else {
        return;
      }
    },
    async getPedido() {
      try {
        const pedido = await pedidoService.getPedido(this.id);
        if (pedido && pedido.id_saida) {
          if (!pedido.itens || !pedido.itens.length) await this.fetchPedidoItensAPI(pedido);
          if (!pedido.parcelas || !pedido.parcelas.length) await this.fetchPedidoParcelasAPI(pedido);
        }
        if (pedido) {
          this.pedido = pedido;
          this.cliente = await clienteService.getClienteFromIndex('id_cliente', this.pedido.id_cliente);
          this.pedido.id_cliente_interno = this.cliente && this.cliente.id_interno;
          if (pedido.id_tabela_preco) this.tabelaPreco = this.tabelasPreco.find(tp => tp.id_tabela_preco == pedido.id_tabela_preco);
        } else {
          this.error = 'Pedido não encontrado.';
        }
      } catch (error) {
        this.error = 'Pedido não encontrado.';
        console.log(error);
      }
    }
  },
  created() {
    this.getPedido();
    this.getCondicoesPagamento();
    this.getTabelasPreco();
  },
}
</script>

<style scoped>
.itens-container {
  max-height: 600px;
  overflow: auto;
}
</style>